/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Social_Science18Inputs */

const en__field_enum_icsrm_social_science18 = /** @type {(inputs: _Field_Enum_Icsrm_Social_Science18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social Sciences`)
};

const de__field_enum_icsrm_social_science18 = /** @type {(inputs: _Field_Enum_Icsrm_Social_Science18Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sozialwissenschaften`)
};

/**
* | output |
* | --- |
* | "Social Sciences" |
*
* @param {_Field_Enum_Icsrm_Social_Science18Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_social_science18 = /** @type {((inputs?: _Field_Enum_Icsrm_Social_Science18Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Social_Science18Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_social_science18(inputs)
	return de__field_enum_icsrm_social_science18(inputs)
});
export { _field_enum_icsrm_social_science18 as "_field_enum_ICSRM_SOCIAL_SCIENCE" }